/* Conteggio recensioni Judge.me in tedesco.
   L'app scrive "698 reviews" in inglese. Qui:
   - se il testo dell'app e' gia' tedesco ("Bewertung/en") lo lasciamo stare;
   - altrimenti lo nascondiamo e scriviamo noi "698 Bewertungen".

   ATTENZIONE: questo script scrive nel DOM ed e' osservato da un
   MutationObserver. Ogni scrittura va fatta SOLO se il valore cambia
   davvero e con l'observer staccato, altrimenti si innesca un ciclo
   infinito che blocca la pagina. */
(function () {
  var TRIES = 40, DELAY = 300;
  var observer = null;
  var scheduled = false;

  function label(n) {
    return n === 1 ? '1 Bewertung' : n.toLocaleString('de-DE') + ' Bewertungen';
  }

  function apply(badge) {
    var n = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
    if (isNaN(n) || n < 1) return;

    var appText = badge.querySelector('.jdgm-prev-badge__text');
    var mine = badge.querySelector('.alv-jdgm-count');

    // l'app lo scrive gia' in tedesco: non tocchiamo niente
    if (appText && /bewertung/i.test(appText.textContent || '')) {
      if (appText.classList.contains('alv-hide')) appText.classList.remove('alv-hide');
      if (mine) mine.parentNode.removeChild(mine);
      return;
    }

    if (appText && !appText.classList.contains('alv-hide')) {
      appText.classList.add('alv-hide');
    }

    var text = label(n);
    if (mine) {
      if (mine.textContent !== text) mine.textContent = text;  // solo se cambia
      return;
    }
    var span = document.createElement('span');
    span.className = 'alv-jdgm-count';
    span.textContent = text;
    badge.appendChild(span);
  }

  function render() {
    var badges = document.querySelectorAll('.jdgm-prev-badge[data-number-of-reviews]');
    if (!badges.length) return false;
    if (observer) observer.disconnect();          // non osservare le nostre scritture
    try {
      Array.prototype.forEach.call(badges, apply);
    } finally {
      if (observer) {
        observer.observe(document.body, { childList: true, subtree: true });
      }
    }
    return true;
  }

  function schedule() {
    if (scheduled) return;                         // accorpa le chiamate ravvicinate
    scheduled = true;
    setTimeout(function () { scheduled = false; render(); }, 150);
  }

  function start() {
    var left = TRIES;
    var timer = setInterval(function () {
      render();
      if (--left <= 0) clearInterval(timer);
    }, DELAY);

    if (window.MutationObserver) {
      observer = new MutationObserver(schedule);
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        if (observer) { observer.disconnect(); observer = null; }
      }, TRIES * DELAY);
    }
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
